export default "__VITE_ASSET__e93570c1__"